// extracted by mini-css-extract-plugin
export default {"gridCell":"GridCell__gridCell___BJ_9mTMJ"};